var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-tabs-panel"},[_c('i-table',{ref:"table",attrs:{"columns":_vm.columns,"queryParams":_vm.queryParams,"url":_vm.url}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }